import { ViewCategory, FolderType } from "src/Models/CustomViewFolder";
import { ViewTypes } from "../ManageViewConstants";

export const GetViewCategoryFromScopeType = (scopeType: string, docType: string): ViewCategory => {
    if (docType === 'Folder') {
        return ViewCategory.Folder;
    } else if (scopeType === 'System') {
        return ViewCategory.SystemView;
    } else if (scopeType === 'Shared') {
        return ViewCategory.SharedView;
    } else if (scopeType === 'SharedWithMe') {
        return ViewCategory.SharedWithMe;
    } else {
        return ViewCategory.UserView;
    }
}

export const GetFolderTypeFromScopeType = (scopeType: string): FolderType => {
    if (scopeType === 'System') {
        return FolderType.System;
    } else if (scopeType === 'Shared') {
        return FolderType.Shared;
    } else if (scopeType === 'SharedWithMe') {
        return FolderType.SharedWithMe;
    } else {
        return FolderType.User;
    }
}

export const GetViewTypeFromScopeType = (scopeType: string): ViewTypes => {
    if (scopeType === 'System') {
        return ViewTypes.system;
    } else if (scopeType === 'Shared') {
        return ViewTypes.shared;
    } else if (scopeType === 'SharedWithMe') {
        return ViewTypes.sharedWithMe;
    } else {
        return ViewTypes.user;
    }
}